import i18n from 'i18n'
import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    { label: '1 night', value: 1 },
    { label: '2 nights', value: 2 },
    { label: '3 nights', value: 3 },
    { label: '4 nights', value: 4 },
    { label: '5 nights', value: 5 },
    { label: '6 nights', value: 6 },
    { label: '7 nights', value: 7 },
    { label: '8 nights', value: 8 },
    { label: '9 nights', value: 9 },
    { label: '10 nights', value: 10 },
    { label: '11 nights', value: 11 },
    { label: '12 nights', value: 12 },
    { label: '13 nights', value: 13 },
    { label: '14 nights', value: 14 },
]

export default function SelectNightsStatic({...props}) {
    const myProps = {
        placeholder: i18n.t('common:filters.nights'),
        formatOptionLabel: opt => i18n.t('common:units.nights', { count: Number(opt?.value) }),
        firstSelect: false,
        options: OPTIONS,
        icon: { icon: 'moon-stars' },
        isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}